module.exports = __webpack_public_path__ + "img/layout.e9f75c46.png";